/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AccountStatus } from './accountStatus';
import { Reaction } from './reaction';

export interface UserBasic { 
    user_id: string;
    /**
     * individual alias or organization name
     */
    displayed_name: string;
    is_admin: boolean;
    image_url?: string;
    /**
     * channel_external_id if already exists
     */
    chat?: string;
    account_status: AccountStatus;
    reaction?: Reaction;
}